export declare namespace AppSurfaceTokenSections {
	interface Subtle {
		background: string;
	}

	interface Muted {
		background: string;
	}

	interface Neutral {
		background: string;
	}

	interface Highlight {
		background: string;
		hoverBackground: string;
	}

	interface Success {
		background: string;
	}

	interface Border {
		color: string;
		subtleColor: string;
	}
}

export type AppSurfaceTokens = {
	background: string;
	subtle: AppSurfaceTokenSections.Subtle;
	muted: AppSurfaceTokenSections.Muted;
	neutral: AppSurfaceTokenSections.Neutral;
	highlight: AppSurfaceTokenSections.Highlight;
	success: AppSurfaceTokenSections.Success;
	border: AppSurfaceTokenSections.Border;
};

export const subtle: AppSurfaceTokenSections.Subtle = { background: '{surface.50}' };

export const muted: AppSurfaceTokenSections.Muted = { background: '{surface.100}' };

export const neutral: AppSurfaceTokenSections.Neutral = { background: '{neutral.50}' };

export const highlight: AppSurfaceTokenSections.Highlight = {
	background: '{highlight.background}',
	hoverBackground: '{primary.100}',
};

export const success: AppSurfaceTokenSections.Success = { background: '{green.600}' };

export const border: AppSurfaceTokenSections.Border = { color: '{content.border.color}', subtleColor: '{surface.100}' };

/** Background and border colour roles for plain template boxes (`.app-surface*` / `.app-border*` in `css/appSurface`). */
export default {
	background: '{content.background}',
	subtle,
	muted,
	neutral,
	highlight,
	success,
	border,
} satisfies AppSurfaceTokens;
